import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import * as React from "react";
import DynamicCard from "./CardComponent";
import { callApi } from "../../common/api";
import Backdrop from '@mui/material/Backdrop';
import Modal from '@mui/material/Modal';
import CustomizedSnackbars from "../alert/alert";
import WatchlistPay from "../../components/Investor/WatchlistPay.js"

export default function MyWatchlist() {
  const [data, setData] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  const [sid, setSid] = React.useState("");
  const [payment, setPayment] = React.useState(false)

  const getPaymentData = async () => {
    const response = await callApi("get", "investor/getPayment")
    setPayment(response?.data?.response?.data?.isPaymentDone)
  }

  React.useEffect(() => {
    getPaymentData();
  }, []);

  const [snackBarMsg, setSnackBarMsg] = React.useState({
    message: "",
    severity: "success",
    open: false,
  });

  async function handleGet() {
    try {
      const response = await callApi("get", "/watchList/getWatchList");
      if (response.data.response.status) {
        const data = response.data.response.data;
        setData(data);
        // setSnackBarMsg({
        //   message: "watchList Details fetched sucessfully",
        //   severity: "success",
        //   open: true,
        // });
      } else {
        setSnackBarMsg({
          message: "Some error occur",
          severity: "error",
          open: true,
        });
      }
    } catch {
      setSnackBarMsg({
        message: "Some error occur",
        severity: "error",
        open: true,
      });
    }
  }
  async function handleDelete(startupId) {
    try {
      const response = await callApi(
        "delete",
        `/watchList/deleteWatchList?startupId=${startupId}`
      );
      if (response.data.response.status) {
        setSnackBarMsg({
          message: response.data.response.message,
          severity: "success",
          open: true,
        });
        handleGet();
      } else {
        setSnackBarMsg({
          message: "Some error occur",
          severity: "error",
          open: true,
        });
      }
    } catch {
      console.log("this is error  ");
    }
  }
  const handleClose = () => {
    setOpen(false);
  };

  React.useEffect(() => {
    handleGet();
  }, []);

  const handleClick = (id) => {
    setSid(id);
    setOpen(true);
  };
  const handleClicks = (dealId, startUpId) => {
    localStorage.setItem("startUpId", JSON.stringify(startUpId));
    localStorage.setItem("dealId", JSON.stringify(dealId));

    window.location.href = "/startUpDetails";
  };
  
  return (
    <>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >

        <Box
          sx={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            overflowY: "auto",
            overflowX: "hidden",
            maxHeight: "100vh",
            width: "100%",
            color: "yellow"
          }}

        >
          <WatchlistPay handleClose={handleClose} sid={sid} />
        </Box>
      </Modal>

      <Box className="container" sx={{ width: "100%", marginBottom: '24px' }}>
        <Typography
          variant="h5"
          style={{ color: "white", paddingBottom: "12px" }}
        >
          My Watchlist{" "}
          <Typography
            component="span"
            variant="h6"
            style={{ fontSize: "15px" }}
          >
            ({data.length} Deals)
          </Typography>
        </Typography>
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: '24px' }}>
          {data.map((d, index) => (
            <>
              <Box className="cardWidth">
                <DynamicCard
                  payment={payment}
                  sx={{ border: "1px solid red" }}
                  key={index}
                  num={1}
                  imageData={
                    d.startUpInfo != null
                      ? d.startUpInfo.startupDeals[0].startupDealsDocs[0]
                        .document.link
                      : "https://upload.wikimedia.org/wikipedia/commons/b/bf/Incred-logo.jpg"
                  }
                  startUpId={d.startupId}
                  dealid={
                    d.startUpInfo != null
                      ? d.startUpInfo.startupDeals[0].id
                      : "null"
                  }
                  onButtonClick1={handleClick}
                  onButtonClick={handleClicks}
                  onDeleteButton={handleDelete}
                  resource={d.startUpInfo?.startupDeals[0]?.resources?.basicDetails}
                />
              </Box>
            </>
          ))}
        </Box>
      </Box>
      <CustomizedSnackbars msgData={snackBarMsg} setMsgData={setSnackBarMsg} />
    </>
  );
}
